import { render, staticRenderFns } from "./ContactFooter.vue?vue&type=template&id=597ead2a&"
import script from "./ContactFooter.vue?vue&type=script&lang=js&"
export * from "./ContactFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports